import classNames from 'classnames';
import React from 'react';

interface Props {
  backgroundColor?: string;
  width?: string;
  height?: string;
  className?: string; // Tailwind class name
}

const MHSkeleton: React.FC<Props> = ({ backgroundColor, width, height, className }) => (
  <span
    className={classNames(
      `flex relative overflow-hidden rounded-lg after:skeleton-after ${className}`,
      {
        'bg-gray-250': !backgroundColor,
        'h-5': !height,
        'w-auto': !width,
        [`h-${height}`]: !!height,
        [`w-${width}`]: !!width,
        [`bg-${backgroundColor}`]: !!backgroundColor,
      },
    )}
  />
);

export default MHSkeleton;
